<template>
  <div
    class="base-navigation-bar"
    :style="{ flexWrap: props.withWrap ? 'wrap' : 'nowrap' }"
  >
    <div class="base-navigation-bar__title">
      <slot name="title">
        <BaseButtonBack
          size="md-alt"
          class="base-navigation-bar__left-btn"
          :has-click-back="props.hasClickBack"
          :fallback-route="props.fallbackRoute"
          @click="emit('clickBack')"
        />
        <slot name="title-text">
          <span>
            {{ props.title }}
          </span>
        </slot>
        <div v-if="$slots['title-actions']" class="base-navigation-bar__right-btn">
          <slot name="title-actions" />
        </div>
      </slot>
    </div>
    <slot name="actions" v-bind="{ groupStyle }" />
  </div>
</template>

<script setup lang="ts">
import type { CSSProperties } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

import BaseButtonBack from '../button-back/index.vue'

interface Props {
  title?: string
  withWrap?: boolean
  hasClickBack?: boolean
  fallbackRoute?: RouteLocationRaw
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'clickBack'): void
}>()

const groupStyle: CSSProperties = {
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flex: '1 1 auto',
}
</script>

<style lang="scss" scoped>
.base-navigation-bar {
  position: relative;
  padding-top: rem(32px);
  padding-bottom: rem(12px);
  gap: rem(8px);
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include bp-media('xs', 'sm') {
    gap: rem(8px);
    padding-top: rem(26px);
  }

  &__title {
    @include typo-h5;

    height: 40px;
    display: inline-flex;
    align-items: center;
    gap: rem(16px);
    margin-right: rem(16px);
    overflow: hidden;

    @include bp-media('xs', 'sm', 'md') {
      margin-right: rem(8px);
    }

    @include bp-media('xs', 'sm') {
      font-size: rem(20px);
      height: 34px;
      flex-basis: 100%;
      margin-right: 0;
      display: flex;

      .base-navigation-bar__left-btn {
        height: 34px;
        width: 34px;
      }

      .base-navigation-bar__right-btn .base-button-icon {
        height: 34px;
        width: 34px;
      }
    }

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
